// extracted by mini-css-extract-plugin
export default {"parent":"NotFound404-module__parent__iOCPz","child":"NotFound404-module__child__QssAj"};